import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';

// components
import { Button, Label, FormGroup, Form, Input, Row, Col, Spinner } from "reactstrap";
import Select from 'react-select'
import Switch from 'react-switch';
import InputDatePickerMesAno from "components/Inputs/InputDatePickerMesAno";

// utils
import { showMessage } from "utils/message.js";
import { formateMesAno, formateDateByMesAno } from "utils/formats";
import { getSessionCookie } from 'utils/cookies';

// api
import usuario_api from "api/usuario_api.js";
import dadosimplantacaotim_api from 'api/dadosimplantacaotim_api';
import dreexcecoes_api from "api/dreexcecoes_api";

export default function DREExcecaoFicha({ handleReturn }) {

    var session = getSessionCookie();

    const { register, errors, handleSubmit, setValue, clearErrors } = useForm({ mode: "onBlur" });
    const [showLoading, setshowLoading] = useState(false);
    const [startDate, setStartDate] = useState(formateDateByMesAno(session.mesAnoDefault));

    //===================================================================================CARREGA/SELECIONA REGIONAIS================================================================================================//

    useEffect(() => {
        loadOptionsRegionais();
    }, []);

    const [options_regionais, set_options_regionais] = useState([]);
    const loadOptionsRegionais = () => {
        dadosimplantacaotim_api.getRegionais().then(result => {
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                let _regionais = [];
                result.data.map((m) => _regionais.push({ label: m, value: m }));
                set_options_regionais(_regionais);
                if (_regionais.length == 1) {
                    set_regional(_regionais[0].value);
                    loadOptionsGruposEconomicos(_regionais[0].value);
                }
            }
        })
    }
    const [regional, set_regional] = useState(null);
    const handleChangeRegional = (value) => {
        set_regional(value.value);
        set_grupoeconomico(null);
        loadOptionsGruposEconomicos(value.value);
    }
    //=======================================================================================================================================================================================================//

    //===================================================================================CARREGA/SELECIONA GRUPOS ECONOMICOS================================================================================================//
    const [options_gruposeconomicos, set_options_gruposeconomicos] = useState([]);

    const loadOptionsGruposEconomicos = (_regional) => {
        dadosimplantacaotim_api.getGruposEconomicos(_regional).then(result => {
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                let _gruposeconomicos = [];
                result.data.map((m) => _gruposeconomicos.push({ label: m, value: m }));

                set_options_gruposeconomicos(_gruposeconomicos);
            }
        })
    }
    const [grupoeconomico, set_grupoeconomico] = useState(null);
    const handleChangeGrupoEconomico = (value) => {
        set_grupoeconomico(value.value);
        set_loja(null);
        loadOptionsLojas(value.value);
    }
    //=======================================================================================================================================================================================================//
  
    //===================================================================================CARREGA LOJAS================================================================================================//

    const [options_lojas, set_options_lojas] = useState([]);
    const [loja, set_loja] = useState(null);
    const loadOptionsLojas = (_grupoeconomico) => {
        dadosimplantacaotim_api.getLojas(regional, _grupoeconomico).then(result => {
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                set_options_lojas(result.data);
            }
        });
    }
    //=======================================================================================================================================================================================================//


    //===================================================================================SALVAR DRE EXCEÇÃO================================================================================================//
    const onSubmit = (data) => {

        if (loja == null) {
            showMessage("Aviso", "É preciso selecionar a Loja para salvar!", 'error', null);
            return;
        }

        let json_submit = {
            dreExcecaoID: 0,
            grupoEconomico: grupoeconomico,
            custCode: loja.identificacao,
            custCodeID: loja.dadosImplantacaoTim_Id,
            mesAno: formateMesAno(startDate).replace("/", "-"),
            motivoExcecao: data.motivoExcecao,
            usuario: session.nome,
            datahora: ""
        };

        setshowLoading(true);

        dreexcecoes_api.post(json_submit).then(result => handleReturnSubmit(result));
    }

    const handleReturnSubmit = (result) => {
        setshowLoading(false);
        if (result.status !== 200) {
            showMessage("Aviso", result.message, 'error', null);
        }
        else {
            showMessage("Aviso", "Operação executada com sucesso!", 'success', handleReturn);
        }
    }
    //=======================================================================================================================================================================================================//

    const Voltar = () => {
        handleReturn();
    }
    
    return (
        <>
            {showLoading &&
                <div className="carregandoCmp">
                    <div className="box">
                        <Spinner></Spinner>
                    </div>
                </div>
            }
            <div className="content">
                <h5>Dados de Exceção </h5>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <Row>
                        <Col lg="2" md="6" sm="12">
                            <FormGroup>
                                <label className="form-control-label">Mês/Ano *</label>
                                <InputDatePickerMesAno selected={startDate} onChange={(date) => setStartDate(date)} ></InputDatePickerMesAno>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row className="mb-4 align-items-end">
                        <Col lg="2" md="6" sm="12">
                            <FormGroup>
                                <label className="form-control-label">Regional *</label>
                                <Select
                                    name="regional"
                                    options={options_regionais}
                                    getOptionLabel={o => o.label}
                                    getOptionValue={o => o.value}
                                    value={options_regionais.filter(f => f.value == regional)}
                                    onChange={(o) => handleChangeRegional(o)}
                                    classNamePrefix="select"
                                    placeholder="[ Selecione ]"
                                    ref={e => register({ name: "regional" })
                                    }
                                />
                            </FormGroup>
                        </Col>
                        <Col lg="4" md="6" sm="12">
                            <FormGroup>
                                <label className="form-control-label">Grupo Econômico *</label>
                                <Select
                                    name="grupoeconomico"
                                    options={options_gruposeconomicos}
                                    getOptionLabel={o => o.label}
                                    getOptionValue={o => o.value}
                                    value={options_gruposeconomicos.filter(f => f.value == grupoeconomico)}
                                    onChange={(o) => handleChangeGrupoEconomico(o)}
                                    classNamePrefix="select"
                                    placeholder="[ Selecione ]"
                                    ref={e => register({ name: "grupoeconomico" })
                                    }
                                />
                            </FormGroup>
                        </Col>
                        <Col lg="6" md="6" sm="12">
                            <FormGroup>
                                <label className="form-control-label">Loja *</label>
                                <Select
                                    name="lojas"
                                    options={options_lojas}
                                    getOptionLabel={o => o.identificacao}
                                    getOptionValue={o => o.dadosImplantacaoTim_Id}
                                    value={loja}
                                    onChange={(o) => set_loja(o)}
                                    classNamePrefix="select"
                                    placeholder="[ Selecione ]"
                                    ref={e => register({ name: "lojas" })
                                    }
                                />
                            </FormGroup>
                        </Col>
                        <Col lg="12" md="12" sm="12">
                            <FormGroup>
                                <Label>Motivo Exceção *</Label>
                                <Input className="form-control"
                                    autoComplete="off"
                                    type="textarea"
                                    name="motivoExcecao"
                                    maxLength="500"
                                    innerRef={register({ required: true })}
                                />
                                {errors.motivoExcecao && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg="12" md="12" sm="12" className="text-center">
                            <Button color="link" onClick={Voltar}>Voltar</Button>
                            <Button color="success" type="submit"><i className="fas fa-save"></i>  Salvar</Button>
                        </Col>
                    </Row>
                </Form>
            </div>
        </>
    );
}

